// extracted by mini-css-extract-plugin
export default {"bannerBox":"StoreBanner_bannerBox__Mlqp+"};